import 'url-polyfill';
import './assets/app.scss';

import {
  faAdjust,
  faArrowLeft,
  faBars,
  faCaretDown,
  faCaretRight,
  faDownload,
  faFolder,
  faFolderOpen,
  faImages,
  faWindowRestore,
} from '@fortawesome/free-solid-svg-icons';

import App from '@/App.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Vue from 'vue';
import bugsnag from 'bugsnag-js';
import bugsnagVue from 'bugsnag-vue';
import jQuery from 'jquery';
import { library } from '@fortawesome/fontawesome-svg-core';
import router from './router';
import store from './store';

if (process.env.BUGSNAG_KEY) {
  const bugsnagClient = bugsnag(process.env.BUGSNAG_KEY);

  bugsnagClient.use(bugsnagVue(Vue));
}

// Cast required due to type mismatch between fontawesome-svg-core 1.3.x and free-*-svg-icons 5.x.
// Remove when upgrading to FontAwesome v6.
library.add(
  ...([
    faFolder,
    faFolderOpen,
    faDownload,
    faWindowRestore,
    faArrowLeft,
    faBars,
    faAdjust,
    faImages,
    faCaretDown,
    faCaretRight,
  ] as any[])
);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

document.domain = process.env.VUE_APP_HOSTNAME as string;

// showcaseAdMasterCore.js looks for google tag manager to be present on the parent
// document (the review panel or ESPN.com for example). It specifically tries to
// look for ?npa=1 on the querystring of what appears to be some ad unit on ESPN.com.
//
// This code allows the review panel to NOT provide google tag manager, while giving
// showcaseAdMasterCore.js the API it expects. We do NOT want to act as if ?npa=1
// was on the querystring of that other ad unit because it causes the auto to not expand.
(window as any).googletag = {
  pubads: () => ({
    getSlots: () => [
      {
        getContentUrl: () => '',
      },
    ],
  }),
};
(window as any).$ = jQuery;
(window as any).jQuery = jQuery;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
